import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import martha from "../../../Recursos/mart.png"; // ajusta la ruta

const Portada_Martha = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            component="section"
        >
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, px: 3, pt: 12 }}
            >
                {/* Texto izquierda */}
                <Grid size={{ xs: 12, sm: 12, md: 6 }}>

                    <Typography
                        component="h1"
                        sx={{
                            fontSize: sCell ? '36px' : '52px',
                            fontWeight: 700,
                            color: '#223B59',
                            lineHeight: 1.2,
                            mb: 5,
                        }}
                    >
                        Martha Carolina Álvarez
                    </Typography>

                    <Typography component="p" sx={{ fontSize: 15, color: '#223B59', lineHeight: 1.8, mb: 3 }}>
                        Arquitecta, diseñadora de interiores y también mamá. En Espacio Compacto Arquitectura entendemos lo que significa vivir o trabajar en espacios reducidos: la incomodidad, el caos, la sensación de que nada encaja. Por eso creamos soluciones de diseño funcional pensadas específicamente para espacios pequeños, integrando estética, orden y bienestar. No se trata solo de decorar, sino de transformar cómo habitas tu día a día. Con técnicas prácticas, asesorías claras y propuestas visuales accesibles, te ayudamos a optimizar cada metro cuadrado para que vivas bonito, cómodo y en equilibrio con tu entorno.
                    </Typography>

                    <Typography component="p" sx={{ fontSize: 15, color: '#223B59', lineHeight: 1.8 }}>
                        Nuestra metodología está diseñada para resolver problemas reales de forma sencilla, con resultados que se sienten y se disfrutan. Porque no necesitas más espacio. Necesitas un espacio que funcione para ti. Bienvenido(a) a este espacio compacto… pero lleno de posibilidades. ¡Gracias por estar aquí!
                    </Typography>
                </Grid>

                {/* Imagen derecha */}
                {!sCell && (
                    <Grid
                        size={{ xs: 12, sm: 12, md: 6 }}
                        container
                        justifyContent="flex-end"
                        alignItems="flex-end"
                    >
                        <img
                            src={martha}
                            alt="Martha Carolina Álvarez - Arquitecta y diseñadora de interiores"
                            style={{
                                width: '100%',
                                objectFit: 'cover',
                                display: 'block',
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default Portada_Martha;